import axios from 'axios';
import {
    BASE_URL,
    ORCHESTRATION,
    SERVICE_VERSION,
} from './configuration';
import { ORCHESTRATION_SERVICE_ENDPOINT } from './configuration/orchestration-service';
export const ORCHESTRATION_SERVICE_URL = `${BASE_URL}/${ORCHESTRATION}/${SERVICE_VERSION}`;


export const getCartProductDetails = (payload) => {
    return axios({
        method: 'POST',
        url: ORCHESTRATION_SERVICE_URL + ORCHESTRATION_SERVICE_ENDPOINT.VALIDATE_PRODUCT_TENANT,
        headers: {
            'Content-Type': 'application/json'
        },
        params: {
            productPublishedTenant: process.env.REACT_APP_BUYER_X_TENANT
        },
        data: payload
    }).then((response) => {
        return response.data;
    });
};